/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-no-bind */
// import { useState } from 'react'
import {
  Form,
  //  FormControl
} from 'react-bootstrap'
// import { useNewUsers } from '../../pages/NewUsers/useNewUsers'
import { SaveAnimated } from '../SaveAnimated'
import {
  ContainerModalSend,
  SendStyle,
  ListStyle,
  Componentes,
  ButtonSave,
  Title,
  ButtonClosed,
  ButtonClosedOption,
  Option,
  OptionActive,
} from './styles'
import Close from '../../assets/icons/close'
import { CloseOption } from '../../assets/icons/closeOption'
import { useSendIvitation } from './useSendIvitation'

type SendInvitationProps = {
  closed: () => void
}

export function SendInvitation({ closed }: SendInvitationProps) {
  const {
    openModal,
    enviaEmail,
    openModal2,
    value,
    emails,
    selectedOptions,
    handleDeleteOption,
    handleKeyDownOption,
    handleKeyDownEnter,
    handleChange,
    handleSelectOption,
    formatoDeEmail,
    setformatoDeEmail,
  } = useSendIvitation()
  return (
    <>
      <ContainerModalSend>
        <SendStyle>
          {/* <form onSubmit={handleSubmit(onSubmit)}>
            <ListStyle>
              <Componentes>
                <label htmlFor="email">E-mail</label>
                <input id="email" type="text" />
              </Componentes>
              <Componentes>
                <label htmlFor="email">E-mails</label>
                <select>
                  <option hidden>.</option>
                  {Users.map(User => (
                    <option>{User.email}</option>
                  ))}
                </select>
              </Componentes>
            </ListStyle>
            <ButtonSave
              id="salvar"
              type="submit"
              onClick={() => setOpenModal(!openModal)}
            >
              Enviar
            </ButtonSave>
          </form> */}
          <Form>
            <ListStyle>
              <Title>
                <h1>Enviar convite</h1>
                <ButtonClosed type="button" onClick={closed}>
                  <Close />
                </ButtonClosed>
              </Title>
              {/* <FormControl
              type="text"
              placeholder="Digite algo..."
              value={value}
              onChange={handleChange}
            />
            {emails.length > 0 && (
              <ul>
                {emails.map(suggestion => (
                  <li key={suggestion}>{suggestion}</li>
                ))}
              </ul>
            )} */}
              {/* <Componentes>
                <label htmlFor="email">E-mail</label>
                <input
                  className="somenteLeitura"
                  readOnly
                  value="predict@predict.com.br"
                  id="email"
                  type="text"
                />
              </Componentes> */}
              <div>
                <Componentes>
                  <label htmlFor="email">E-mails</label>
                  <input
                    type="email"
                    value={value}
                    onChange={handleChange}
                    onKeyDown={handleKeyDownEnter}
                  />
                  {formatoDeEmail ? (
                    <span>*Formato de email invalido</span>
                  ) : (
                    ''
                  )}
                </Componentes>
                <div>
                  {emails.map(option => (
                    <div
                      key={option}
                      onClick={() => handleSelectOption(option)}
                      onKeyDown={handleKeyDownOption}
                    >
                      <Option>{option}</Option>
                    </div>
                  ))}
                </div>

                <div>
                  <OptionActive>
                    {selectedOptions.map(option => (
                      <div key={option}>
                        <Option>
                          {option}
                          <ButtonClosedOption
                            type="button"
                            onClick={() => handleDeleteOption(option)}
                          >
                            <CloseOption />
                          </ButtonClosedOption>
                        </Option>
                      </div>
                    ))}
                  </OptionActive>
                </div>
              </div>
              <ButtonSave
                type="button"
                id="salvar"
                onClick={() =>
                  (selectedOptions.length > 0 &&
                    selectedOptions.every(email => email.includes('@'))) ||
                  (value.length > 0 &&
                    value.includes('@') &&
                    selectedOptions.every(email => email.includes('@')))
                    ? enviaEmail()
                    : setformatoDeEmail(true)
                }
              >
                Enviar
              </ButtonSave>
            </ListStyle>
          </Form>
        </SendStyle>
      </ContainerModalSend>
      {openModal && <SaveAnimated mensagem="convite" />}
      {openModal2 && <SaveAnimated mensagem="semConvite" />}
    </>
  )
}
